const getElemHeight = (elem) => elem.offsetHeight
const productContainer = () => document.querySelector('.gdc-main-product')
const themeCartButton = () => document.querySelector('[data-js-gdc-product-add-to-cart]')
const stickyCartButton = () => document.querySelector('[data-js-gdc-product-sticky-add-to-cart]')
const showStickyButton = () => stickyCartButton().classList.add('gdc-show')
const hideStickyButton = () => stickyCartButton().classList.remove('gdc-show')
const handleStickyCartButton = () => themeCartButton() && themeCartButton().click()
const scrolledBelowProduct = () => window.scrollY > getElemHeight(productContainer())

function handleStickyCartBtn() {
  scrolledBelowProduct() && !atPageBottom() ? showStickyButton() : hideStickyButton()
}

if (themeCartButton()) {
  window.addEventListener('scroll', handleStickyCartBtn)
  document.addEventListener('DOMContentLoaded', handleStickyCartBtn)
}
